
import * as commonConst from '../common/constants';
import * as recycleConst from './constants';
import * as recycleApis from '../../services/apis/recycle';

export default {
    [recycleConst.kecDescribeInstances](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, recycleApis.kecDescribeInstances);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(recycleConst.kecDescribeInstances, {
                    list: data.FormedInstanceDataArray,
                    total: data.InstanceCount
                });
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [recycleConst.kecGetProjList](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, recycleApis.kecGetProjList);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(recycleConst.kecGetProjList, _.get(data, 'ListProjectResult.ProjectList', []));
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [recycleConst.kecSearchInstances](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, recycleApis.kecSearchInstances);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(recycleConst.kecDescribeInstances, {
                    list: data.FormedInstanceDataArray,
                    total: data.InstanceCount
                });
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [recycleConst.RecoveryInstances](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, recycleApis.RecoveryInstances);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [recycleConst.DeleteInstances](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, recycleApis.DeleteInstances);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },

};
